enum EnumDocumentStatus {
  draft = 'draft',
  scheduled = 'scheduled',
  sent = 'sent',
  viewed = 'viewed',
  reviewed = 'reviewed',
  signed = 'signed',
  rejected = 'rejected',
  hardbounced = 'hardbounced',
  recalled = 'recalled',
  sealed = 'sealed',
  importing = 'importing',
  lost = 'lost',
  processing = 'processing',
  signedwithoutverification = 'signedwithoutverification',
  approved = 'approved',
}

export default EnumDocumentStatus;
